import { createSlice } from '@reduxjs/toolkit';
import { API_STATUS } from 'constants/constants';

const list = createSlice({
  name: 'list',
  initialState: {},
  reducers: {
    fetchData(state, action) {
      const { name } = action.payload;
      state = {
        ...state,
        [name]: {
          ...state[name],
          status: API_STATUS.PROCESSING,
        },
      };
      return state;
    },
    fetchDataError(state, action) {
      const { name, error } = action.payload;
      state = {
        ...state,
        [name]: {
          ...state[name],
          status: API_STATUS.ERROR,
          error,
        },
      };
      return state;
    },
    fetchDataSuccess(state, action) {
      const { name, data, meta } = action.payload;
      state = {
        ...state,
        [name]: {
          ...state[name],
          error: null,
          data,
          meta,
          status: API_STATUS.SUCCESS,
        },
      };
      return state;
    },
  },
});

export const { fetchData, fetchDataError, fetchDataSuccess } = list.actions;

export default list.reducer;
